'use client';

const smallVariants = [
  "body.xs",
  "body.sm",
  "label.xs",
  "label.sm",
  "help-text.xs",
  "help-text.sm"
];
const mediumVariants = [
  "body.base",
  "body.md",
  "body.lg",
  "body.xl",
  "label.md",
  "help-text.md"
];
const largeVariants = ["label.lg", "help-text.lg"];
const allowedVariants = [
  ...smallVariants,
  ...mediumVariants,
  ...largeVariants
];
export {
  allowedVariants,
  largeVariants,
  mediumVariants,
  smallVariants
};
